var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Calculator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculator-NextGen-POS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator-PLU->-Popup",
    transform: "translate(-1289.000000, -694.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator-Search",
    transform: "translate(17.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator-Search-/-Wide",
    transform: "translate(201.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator-Buttons-/-Primary-wIcon-/-Enabled",
    transform: "translate(1053.500000, 388.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Calculator",
    transform: "translate(19.260000, 16.500000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Border",
    stroke: "#FAFAFA",
    strokeWidth: 3,
    x: -0.339931028,
    y: -0.574462286,
    width: 18.6381461,
    height: 24.1531601,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "calculator-Buttons",
    transform: "translate(2.792935, 2.429014)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Rectangle",
    x: 0.25395802,
    y: 5.65484002,
    width: 3.04862745,
    height: 3.04862745
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Copy-3",
    x: 0.25395802,
    y: 10.0902291,
    width: 3.04862745,
    height: 3.04862745
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Copy-6",
    x: 0.25395802,
    y: 14.5256181,
    width: 3.04862745,
    height: 3.04862745
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Copy",
    x: 4.70587346,
    y: 5.65484002,
    width: 3.04862745,
    height: 3.04862745
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Copy-4",
    x: 4.70587346,
    y: 10.0902291,
    width: 3.04862745,
    height: 3.04862745
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Copy-7",
    x: 4.70587346,
    y: 14.5256181,
    width: 3.04862745,
    height: 3.04862745
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Copy-2",
    x: 9.1577889,
    y: 5.65484002,
    width: 3.04862745,
    height: 3.04862745
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Copy-5",
    x: 9.1577889,
    y: 10.0902291,
    width: 3.04862745,
    height: 3.04862745
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Copy-8",
    x: 9.1577889,
    y: 14.5256181,
    width: 3.04862745,
    height: 3.04862745
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calculator-Rectangle",
    x: 6.21724894e-15,
    y: 1.9095836e-13,
    width: 12.1945098,
    height: 3.04862745
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/Calculator.120375f3.svg";
export { ForwardRef as ReactComponent };